import { useInfiniteQuery, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { getCards } from '../../services/cardService';
import { TGetCardsRequestQuery, CardSchema } from '../../types/cards/card-types';

const useGetCards = (
  param?: TGetCardsRequestQuery & { include_batch_cards?: boolean },
  options?: Partial<UseInfiniteQueryOptions<any, any, any, any>>
) => {
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    isPending,
    status,
    isError,
    refetch,
  } = useInfiniteQuery({
    queryKey: ['get-cards', param],
    queryFn: async ({ pageParam }) =>
      getCards({
        next_cursor: pageParam as string | undefined,
        ...param,
      }),
    initialPageParam: '',
    getNextPageParam: (lastPage) => (lastPage as any)?.next_cursor as string | undefined,
    select: (data) => (data as any)?.pages.flatMap((page: any) => page?.cards || []),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    staleTime: 2 * 60 * 1000, // 2 minutes
    ...(options || {}),
  });

  return {
    data: data as unknown as CardSchema[] | undefined,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isPending,
    isFetchingNextPage,
    isError,
    status,
    refetch,
  };
};

export default useGetCards;
